import axios, { AxiosResponse } from 'axios';
import DCApp from "./../Shared/App.vue";
import { MixinConfigurationModule} from "./../Shared/configuration";
import { MixinDetect } from "./../startdetection/index";
import * as Vue from 'vue';
import { VueSignalR } from './../../Scripts/js/signalrmonitoring.service';
import { createSignalRHubConnexion } from "./../Shared/DCSignalRConnection";
import { createPinia } from 'pinia';

export class LandingPageComponent {
    public Init(baseurl: string, dctoolsbackurl: string, dcWebSocketServiceUrl: string, initdesc: string,lancurrent:string,landingpageid:number) {
        (<any>(window)).g_initdesc = initdesc;
        (<any>(window)).g_landingpageid = landingpageid;
        (<any>(window)).g_lancurrent = lancurrent;
        (<any>(window)).g_baseurl = baseurl;
        (<any>(window)).g_dcWebSocketServiceUrl = dcWebSocketServiceUrl;
        (<any>(window)).g_dctoolsbackurl = dctoolsbackurl;
        DCApp.mixins = [MixinDetect, MixinConfigurationModule];
        const app = Vue.createApp(DCApp);
        const pinia = createPinia();
        app.use(pinia);
        const connection = createSignalRHubConnexion(`${dcWebSocketServiceUrl}/SignalRDriversCloud`);
        app.use(VueSignalR, connection);
        app.mount('#rootpage');
    }
}
(<any>(window)).LandingPageComponent = function () { return new LandingPageComponent(); };